import { Component, HostBinding } from "@angular/core";
import { Store, select } from "@ngrx/store";
import { map } from "rxjs/operators";
import { HideToastAction } from "src/storage/application/application.actions";
import { IStore, selectApplicationState } from "src/storage/store";
import { Toast, ToastSeverity } from "./toast";

@Component({
    selector: "app-toasts",
    template: `
        <ngb-toast
            *ngFor="let toast of toasts$ | async"
            [class]="getToastClass(toast)"
            [autohide]="true"
            [delay]="5000"
            (hide)="closeToast(toast)">{{ toast.text }}
            <button (click)="closeToast(toast)"
                class="btn">
                <i class="far fa-times"></i>
            </button>
        </ngb-toast>
    `,
})
export class ToastComponent {
  toasts$
    constructor(public store: Store<IStore>) {
      this.toasts$ = this.store.pipe(
        select(selectApplicationState),
        map(i => i.toasts),
    );

    }


    @HostBinding("class.ngb-toasts")

    closeToast(toast: Toast) {

        this.store.dispatch(HideToastAction({ toast }));
    }

    getToastClass(toast: Toast) {

        const classMap = {
            [ToastSeverity.DANGER]: "bg-danger",
            [ToastSeverity.SUCCESS]: "bg-success",
            [ToastSeverity.DEFAULT]: null,
        };

        return classMap[toast.severity];
    }
}
